var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteSubmitIconDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#aeadad"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2197 14.9697C20.5126 14.6768 20.9874 14.6768 21.2803 14.9697L25.7803 19.4697C25.921 19.6103 26 19.8011 26 20C26 20.1989 25.921 20.3897 25.7803 20.5303L21.2803 25.0303C20.9874 25.3232 20.5126 25.3232 20.2197 25.0303C19.9268 24.7374 19.9268 24.2626 20.2197 23.9697L23.4393 20.75L14.75 20.75C14.3358 20.75 14 20.4142 14 20C14 19.5858 14.3358 19.25 14.75 19.25H23.4393L20.2197 16.0303C19.9268 15.7374 19.9268 15.2626 20.2197 14.9697Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteSubmitIconDisabled);
export default __webpack_public_path__ + "static/media/note-submit-icon-disabled.362b4874f9edd257f5b1ef5ae68aed95.svg";
export { ForwardRef as ReactComponent };